module.exports = __webpack_public_path__ + "img/action-7.8d653a96.svg";